import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type ShiftVersionHistory from 'modules/attendance/store/models/ShiftVersionHistory'

import Item from './Item'

interface ListProps {
  histories: ShiftVersionHistory[]
}

const List = ({ histories }: ListProps) => {
  if (histories.length === 0) {
    return <Box>{i18n.t('clock_in.history.empty_version_histories')}</Box>
  }

  return (
    <>
      <Box gap="s16">
        {histories.map((history, index) => (
          <Item key={index} history={history} />
        ))}
      </Box>
    </>
  )
}

export default observer(List)
